<template>
  <div class="block_wrap">
    <div class="row">
      <div class="col-md-4">
        <fg-input
            v-model="specification_info.default_device_name"
            type="text"
            :label="translate('specification.default_device_name')"
            :placeholder="translate('specification.default_device_name')"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <fg-input
            v-model="specification_info.body_label_print_count"
            type="number"
            :min="1"
            :max="2"
            :label="translate('specification.body_label_print_count')"
            :placeholder="translate('specification.body_label_print_count')"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 default_group">
        <label class="info"> {{ translate('specification.default_group') }} </label>
        <tree-select
            :options="opt_device_groups"
            :placeholder="translate('specification.default_group')"
            v-model="default_group_id"
            :multiple="false"
            :disabled="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <fg-input
            v-model="specification_info.factory_name"
            type="text"
            :label="translate('specification.factory_name')"
            :placeholder="translate('specification.factory_name')"
            :disabled="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('specification.check_factory_test') }}
          </div>
          <label class="switch" @click.prevent="check_factory_test = !check_factory_test">
            <input type="checkbox" v-model="check_factory_test" >
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('specification.requires_otk') }}
          </div>
          <label class="switch" @click.prevent="requires_otk = !requires_otk">
            <input type="checkbox" v-model="requires_otk" >
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('specification.print_wifi_labels') }}
          </div>
          <label class="switch" @click.prevent="print_wifi_labels = !print_wifi_labels">
            <input type="checkbox" v-model="print_wifi_labels" >
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('specification.print_admin_password') }}
          </div>
          <label class="switch" @click.prevent="print_admin_password = !print_admin_password">
            <input type="checkbox" v-model="print_admin_password" >
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('specification.auto_snapshot') }}
          </div>
          <label
              class="switch"
              @click.prevent="auto_snapshot = !auto_snapshot"
          >
            <input type="checkbox" v-model="auto_snapshot" >
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="filter checkbox">
          <div class="info">
            {{ translate('specification.apply_group_config') }}
          </div>
          <label
              class="switch"
              @click.prevent="apply_group_config = !apply_group_config"
          >
            <input type="checkbox" v-model="apply_group_config" >
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="line" v-if="has_changes">
      <div class="button_wrap">
        <button
            class="btn btn-success btn-fill btn-wd"
            @click.prevent="edit_specification"
        >
          {{ translate("btn.edit") }}
        </button>
      </div>
    </div>

  </div>
</template>
<script>

const fields_to_check = [
  "print_admin_password",
  "print_wifi_labels",
  "requires_otk",
  "default_device_name",
  "body_label_print_count",
  "check_factory_test",
  "apply_group_config",
  "auto_snapshot"
];

export default {
  name: 'SpecificationSettings',
  props: ['specification'],

  data () {
    return {
      specification_info: {},
      print_admin_password: false,
      print_wifi_labels: false,
      requires_otk: false,
      check_factory_test: false,
      default_group_id: null,
      factory_name: "",
      apply_group_config: false,
      auto_snapshot: false
    }
  },
  computed:{
    opt_device_groups () {
      return [
        {id: -1, label: this.translate("specification.no_transfer")},
        ...this.$store.getters.getDeviceGroupsTree
      ]
    },
    has_changes() {
      let specification_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.specification_info[key];
        return obj;
      }, {});

      let specification = fields_to_check.reduce((obj, key) => {
        obj[key] = this.specification[key];
        return obj;
      }, {});

      return JSON.stringify(specification_info) !== JSON.stringify(specification);
    }
  },

  watch:{
    specification(){
      this.init()
    },
    print_admin_password(){
      this.specification_info.print_admin_password = Number(this.print_admin_password)
    },
    print_wifi_labels(){
      this.specification_info.print_wifi_labels = Number(this.print_wifi_labels)
    },
    requires_otk(){
      this.specification_info.requires_otk = Number(this.requires_otk)
    },
    check_factory_test(){
      this.specification_info.check_factory_test = Number(this.check_factory_test)
    },
    apply_group_config(){
      this.specification_info.apply_group_config = Number(this.apply_group_config)
    },
    auto_snapshot(){
      this.specification_info.auto_snapshot = Number(this.auto_snapshot)
    },
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      this.specification_info = Object.assign({}, this.specification)
      this.print_admin_password = Boolean(this.specification_info.print_admin_password)
      this.print_wifi_labels = Boolean(this.specification_info.print_wifi_labels)
      this.requires_otk = Boolean(this.specification_info.requires_otk)
      this.check_factory_test = Boolean(this.specification_info.check_factory_test)
      this.apply_group_config = Boolean(this.specification_info.apply_group_config)
      this.auto_snapshot = Boolean(this.specification_info.auto_snapshot)
      this.default_group_id = this.specification_info.default_group_id
    },
    edit_specification() {
      this.$http.v1.putSpecificationInfo(this.specification_info.id, this.specification_info, (response) => {
        this.global_notify('info', this.translate('specification.saved_success'))
        this.specification_info = response.data
        this.$emit('update', response.data)
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .block_wrap{
    text-align: left;
    .row{
      .filter{
        flex-direction: row;
        justify-content: space-between;
      }
      .default_group{
        margin-bottom: 10px;
      }
    }
    .response_table{
      padding: 10px 0 0;
      margin: 0;
    }
  }

  textarea{
    resize: both;
  }


</style>

